import React, { useRef, useEffect, useState } from 'react';
import '../css/HeaderCarousel.css';

const images = [  
  '/images/logoChilesSF.png',  
  '/images/botellaVistaFrentePrincipal.jpeg',
  // '/images/groupSalsas.png',
  '/images/botellasVistalateral.jpeg',
  '/images/botellasVistaFrenteEnfocada.jpeg',
  '/images/botellasVistaFrente.jpeg',
  '/images/marketing.jpeg',
  '/images/logo.jpeg'
];

function HeaderCarousel() {
  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const scrollX = activeIndex * carouselRef.current.offsetWidth;
    carouselRef.current.scrollTo({ left: scrollX, behavior: 'smooth' });
  }, [activeIndex]);


  return (
  <div className="carousel-wrapper">
    <div className="header-carousel" ref={carouselRef} >
      {images.map((src, index) => (
        <div key={index} className="carousel-slide">
          <img src={src} alt={`Slide ${index}`} />
        </div>
      ))}
    </div>
     {/* Indicadores */}
      <div className="carousel-dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => setActiveIndex(index)}
          />
        ))}
    </div>
  </div>
  );
}

export default HeaderCarousel;
